import React from 'react'
import { ClientAccount } from '../types'
import { StatusBadge } from './StatusBadge'
import './RelationshipSnapshot.css'

interface RelationshipSnapshotProps {
  accounts: ClientAccount[]
}

export const RelationshipSnapshot: React.FC<RelationshipSnapshotProps> = ({ accounts }) => {
  const formatCurrency = (amount: number): string => {
    return `$${amount.toLocaleString()}`
  }

  return (
    <div className="relationship-snapshot">
      <h2 className="snapshot-heading">Relationship Snapshot</h2>

      <div className="snapshot-section">
        <h3 className="snapshot-subheading">Accounts</h3>

        {accounts.length === 0 ? (
          <p className="snapshot-empty">No accounts available</p>
        ) : (
          <div className="accounts-list">
            {accounts.map((account) => (
              <div key={account.accountId} className="account-item">
                <div className="account-info">
                  <div className="account-name">{account.accountName}</div>
                  <div className="account-type">{account.accountType}</div>
                </div>
                <div className="account-details">
                  <div className="account-balance">{formatCurrency(account.balance)}</div>
                  <StatusBadge isActive={account.status === 'ACTIVE'} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
